import { http } from "@/core/api";
import type {
  AnalyticsV4EntityResponse,
  AnalyticsV4MatrixResponse,
  AnalyticsV4Query,
  AnalyticsV4SourcesResponse,
} from "@/features/analytics/types/analytics-v4.types";
import { resolveExcelHeavyBlobExport } from "@/shared/utils/excel-heavy-operation";

const BASE = "/analytics/v1";
const EXPORT_TIMEOUT_MS = 300_000;

async function get<T>(path: string, params: AnalyticsV4Query): Promise<T> {
  const { data } = await http.get<{ data: T }>(`${BASE}/${path}`, { params });
  return data.data;
}

export const analyticsV4Api = {
  suppliers: (params: AnalyticsV4Query) =>
    get<AnalyticsV4EntityResponse>("entities/suppliers", params),
  enterprises: (params: AnalyticsV4Query) =>
    get<AnalyticsV4EntityResponse>("entities/enterprises", params),
  matrix: (params: AnalyticsV4Query) =>
    get<AnalyticsV4MatrixResponse>("entity-matrix", params),
  teamClientMatrix: (params: AnalyticsV4Query) =>
    get<AnalyticsV4MatrixResponse>("team-client-matrix", params),
  teams: (params: AnalyticsV4Query) =>
    get<AnalyticsV4EntityResponse>("entities/teams", params),
  teamEnterprises: (params: AnalyticsV4Query) =>
    get<AnalyticsV4EntityResponse>("entities/team-enterprises", params),
  sources: (params: AnalyticsV4Query) =>
    get<AnalyticsV4SourcesResponse>("sources-v4", params),
  async exportEntity(
    entity: "supplier" | "enterprise",
    snapshotId: string,
    locale: string,
  ): Promise<Blob> {
    const path = entity === "supplier" ? "suppliers" : "enterprises";
    const res = await http.get<Blob>(`${BASE}/entities/${path}/export`, {
      params: { snapshot_id: snapshotId },
      responseType: "blob",
      timeout: EXPORT_TIMEOUT_MS,
      validateStatus: (status) => status === 200 || status === 202,
      headers: { "Accept-Language": locale },
    });
    return resolveExcelHeavyBlobExport(res, { timeoutMs: EXPORT_TIMEOUT_MS });
  },
};
